import { clientePedido } from "../../apiClient/index";

const getDefaultDateRange = () => {
  const today = new Date();
  return {
    from: new Date(today.getFullYear(), today.getMonth() - 1, 1),
    to: new Date(today.getFullYear(), today.getMonth(), today.getDate()),
  };
};

const getDefaultFiltersResumenDeCuenta = () => {
  const { from, to } = getDefaultDateRange();
  return {
    cuenta: undefined,
    from,
    to,
    periodo: "RESUMENDECUENTA_periodo_meses_1",
    tipo_filtro: "RESUMENDECUENTA_rango",
    ordenar: "",
    checkPeriodo: false,
    checkRango: true,
    clientes: undefined,
    clienteSeleccionado: undefined,
    clientesOption: undefined,
  };
};

const moduloResumenDeCuenta = {
  namespaced: true,
  state: {
    filtrosResumenDeCuenta: getDefaultFiltersResumenDeCuenta(),
    paginadorDocumentos: {
      page: 1,
      nro_pages: 1,
      pageSize: 10,
    },
  },
  actions: {
    getDocumentos(context, payload) {
      return new Promise((resolve, reject) => {
        clientePedido
          .get("api/Cuentas/GetResumen", { params: payload })
          .then((response) => resolve(response.data))
          .catch(() => reject());
      });
    },
    getCuentas(context, idUsuario) {
      return new Promise((resolve, reject) => {
        clientePedido
          .get("api/Cuentas/GetCuentasCorrientes", {
            params: { idUsuario: idUsuario },
          })
          .then((response) => resolve(response.data))
          .catch(() => reject());
      });
    },
    getCancelaciones(context, payload) {
      return new Promise((resolve, reject) => {
        clientePedido
          .get("api/Cuentas/GetCancelacionesDocumentos", { params: payload })
          .then((response) => resolve(response.data))
          .catch(() => reject());
      });
    },

    setFiltrosResumenDeCuenta(context, payload) {
      context.commit("setFiltrosResumenDeCuenta", payload);
    },
    setPaginadorDocumentos(context, payload) {
      context.commit("setPaginadorDocumentos", payload);
    },
    getRecibo(context, payload) {
      return new Promise((resolve, reject) => {
        clientePedido
          .get("api/Cuentas/GetRecibo", {
            params: { idRecibo: payload.idRecibo },
          })
          .then((response) => {
            resolve(response.data.Datos);
          })
          .catch(() => reject());
      });
    },
    descargarFactura(context, payload) {
      return new Promise((resolve, reject) => {
        clientePedido
          .get("api/Cuentas/DescargarFactura", {
            params: payload,
            responseType: "arraybuffer",
          })
          .then((response) => {
            resolve(response);
          })
          .catch(() => {
            reject();
          });
      });
    },
    exportarExcel(_, payload) {
      return new Promise((resolve, reject) => {
        clientePedido
          .get("/api/cuentas/ExportExcelResumen", { params: payload })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error.response.data);
          });
      });
    },
  },
  mutations: {
    setFiltrosResumenDeCuenta(state, payload) {
      state.filtrosResumenDeCuenta = payload;
    },
    setPaginadorDocumentos(state, payload) {
      state.paginadorDocumentos = payload;
    },
  },
};

export default moduloResumenDeCuenta;
